import { FormControl, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { imageURL } from 'Config/endpoints'
import React, { useState } from 'react'
import { useQuery } from 'react-query';
import { getCustomerNeedFn } from 'Services/Customer/CustomerNeed';

const CustomerNeed = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [totalPage, setTotalPage] = useState(1);

    const handleChange = (event, value) => {
        setPage(value);
    };

    const { data } = useQuery(["customer-need", search, page], () => getCustomerNeedFn({ search: search, page: page }))


    console.log(data?.data)
    return (
        <div className="!bg-slate-100">
            <div className="flex justify-between">
                <div className="p-2">
                    <p className="text-xl !text-black font font-bold">
                        Customer Need List
                    </p>
                </div>
                {/* <div className="p-2 pt-5">
                    <Button variant="outlined" color="primary" onClick={handleToggleAddCustomizationHeader}>
                        <AddIcon />
                        Add Customization Header
                    </Button>
                </div> */}
                {/* <AddCustomiseHeaderForm
                open={toggleAddCustomizationHeader}
                handleClose={handleToggleAddCustomizationHeader}
                ids={ids}
                setIds={setIds}
                header={editHeader}
                refetchHeader={refetchHeader}
            /> */}
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2">
                    <span className="flex gap-3">
                        <input
                            className="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                            placeholder="Search for anything..."
                            type="text"
                            name="search"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                        />
                    </span>
                </div>
                <TableContainer
                    component={Paper}
                    sx={{ width: "100%", maxHeight: 440 }}
                    className="!text-black !mx-auto !bg-white overflow-auto px-2"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Sr.No.
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Product
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Want To
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Name
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Mobile
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Loan Type
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.data?.data?.map((row, index) => (
                                <TableRow key={row?.id} className="!text-slate-700">
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.product_name || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.want_to || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.name || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.mobile || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.loan_type || "--"}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <div className="flex justify-center p-2">
                    <Pagination
                        page={page}
                        count={data?.data?.total_pages ?? 1}
                        onChange={(event, value) => {
                            setPage(value);

                        }}
                        size="small"
                        variant="outlined"
                        color="primary"
                    />


                </div>
            </div>
        </div>
    )
}

export default CustomerNeed